/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: Explore
 *| (C) Copyright IBM Corp. 2018
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */

export const EXPLOREHOSTAPP = '.ExploreHost';
export const EXPLOREHOSTAPP_CONTROLLER = '.ExploreHostAppController';

export class WidgetHostApp {
	constructor(params) {
		this.services = params.services || {};
		this._widgetFeatures = {};
		this._idx2 = {};
	}

	setup() {
		this.services.register(EXPLOREHOSTAPP, {
			deregisterWidget: this.deregisterWidget.bind(this),
			registerFeature: this.registerFeature.bind(this),
			deregisterFeature: this.deregisterFeature.bind(this)
		});

		this.services.register(EXPLOREHOSTAPP_CONTROLLER, {
			activateFeature: this.activateFeature.bind(this),
			getFeature: this.getFeature.bind(this)
		});
	}

	cleanup() {
		this.services.deregister(EXPLOREHOSTAPP);
		this.services.deregister(EXPLOREHOSTAPP_CONTROLLER);
	}

	deregisterWidget(widgetId) {
		const featureNameList = this._idx2[widgetId];
		for (var key in featureNameList) {
			if (featureNameList.hasOwnProperty(key)) {
				delete this._widgetFeatures[featureNameList[key]];
			}
		}
		delete this._idx2[widgetId];
	}

	registerFeature(widgetId, featureName, api) {
		const key = this._key(widgetId, featureName);


		if( !this._widgetFeatures[key]
			|| (this._widgetFeatures[key] && !this._widgetFeatures[key].api) ) {

			this._idx2[widgetId] = this._idx2[widgetId] || [];
			if(this._idx2[widgetId].indexOf(key) === -1) {
				this._idx2[widgetId].push(key);
			}
			this._widgetFeatures[key] = this._widgetFeatures[key] || {};
			this._widgetFeatures[key].api = api; //TODO: use WeakMap
		}

		if( this._widgetFeatures[key].promise ) {
			this._widgetFeatures[key].resolve(true);
			this._widgetFeatures[key].resolve = null;
			this._widgetFeatures[key].promise = null;
		}
	}

	deregisterFeature(widgetId, featureName) {
		const key = this._key(widgetId, featureName);
		if( this._widgetFeatures[key] ) {
			delete this._widgetFeatures[key];
			const featureNameList = this._idx2[widgetId];
			const i = featureNameList.indexOf(key);
			if( i !== -1) {
				featureNameList.splice(i);
			}
			if(featureNameList.length === 0) {
				delete this._idx2[widgetId];
			}
		}
	}

	activateFeature(widgetId, featureName, params) {
		const key = this._key(widgetId, featureName);
		const _activate = () => {
			const feature = this._widgetFeatures[key];
			return feature && feature.api && feature.api.activate(params);
		};

		if(this._hasFeature(key)) {
			return Promise.resolve( _activate() );
		}

		return this._onFeatureAvailable(key, _activate);
	}

	getFeature(widgetId, featureName) {
		const key = this._key(widgetId, featureName);
		const _getFeature = () => {
			return this._widgetFeatures[key].api;
		};

		if(this._hasFeature(key)) {
			return Promise.resolve( _getFeature() );
		}

		return this._onFeatureAvailable(key, _getFeature);
	}

	_onFeatureAvailable(featureName, actionToCall){
		const prom = new Promise(function(resolve){
			const entry = { api: null, resolve: resolve };
			this._widgetFeatures[featureName] = entry;
		}.bind(this))
			.then(actionToCall);
		this._widgetFeatures[featureName].promise = prom;
		return prom;
	}

	_key(widgetId, featureName) {
		return widgetId + featureName;
	}

	_hasFeature(key) {
		return ( this._widgetFeatures[key] );
	}
}



// WEBPACK FOOTER //
// ./src/js/core/WidgetHostApp.js